import { TopBar } from '../../top-bar/TopBar';
import { Footer } from '../../footer/Footer';
import { PublicOptions } from '../../../data/publicOptions';
import { Banner } from './Banner';
import './Home.css';
import { memo, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sponsors } from './Sponsors';
import { SpeakersList } from '../../../data/speakersList';
import { KeynoteList } from '../../../data/KeynotesList';
import { SpeakerModal } from '../speakers/SpeakersWrapper';

const HomeWrapper = memo(() => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const [selectedSpeaker, setSelectedSpeaker] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const selectSpeaker = (speakerId, list) => {
    console.log(speakerId, list);
    const speaker = list.find((speaker) => speaker.id === speakerId);
    setSelectedSpeaker(speaker);
    setIsModalOpen(true);
  };

  const access_token = localStorage.getItem('access_token');

  useEffect(() => {
    if (hash) {
      console.log('Getting token');
      console.log(hash.substring(1));
      const pairs = hash.substring(1).split('&');
      const result = {};

      pairs.forEach((pair) => {
        const [key, value] = pair.split('=');
        result[key] = decodeURIComponent(value);
      });

      localStorage.setItem('id_token', result['id_token']);
      localStorage.setItem('access_token', result['access_token']);
      localStorage.setItem('expires_in', result['expires_in']);
      localStorage.setItem('token_type', result['token_type']);

      navigate('/home');
    }
  }, []);

  useEffect(() => {
    if (access_token) {
      navigate('/home');
    }
  }, []);

  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://connect.facebook.net/es_LA/sdk.js#xfbml=1&version=v5.0';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className={isModalOpen ? '' : 'hide'}>
        <SpeakerModal speaker={selectedSpeaker} closeModal={closeModal} />
      </div>
      <div className="content">
        <Banner />
        <div className="snn-page-section">
          <h1>100 AÑOS DE CUÁNTICA
            ES SOLO EL COMIENZO</h1>
          <p>El año 2025 fue designado como el Año Internacional de la Ciencia y Tecnología Cuántica por la UNESCO, marcando 100 años desde el desarrollo fundamental de la mecánica cuántica.</p>
          <p>Liderada por la nación de México, la iniciativa ganó impulso en mayo de 2023, cuando el Consejo Ejecutivo de la Organización de las Naciones Unidas para la Educación, la Ciencia y la Cultura (UNESCO) respaldó una resolución en apoyo de la proclamación oficial de la ONU. Esto fue seguido por la aprobación formal de la Conferencia General de la UNESCO en noviembre de 2023, copatrocinada por casi 60 países de todo el mundo.</p>
        </div>
        <div className="snn-page-section snn-user-home-main-content-grid">
          <section className="plenary-grid">
            <p className="snn-user-homa-main-content-text">Pláticas invitadas</p>
            <div className="snn-user-home-speakers-wrapper">
              {SpeakersList.map((speaker) => (
                <div
                  className="snn-user-home-main-speaker-wrapper"
                  key={speaker.name}
                  onClick={() => selectSpeaker(speaker.id, SpeakersList)}
                >
                  <img
                    className="snn-user-home-main-speaker-wrapper-speaker"
                    src={speaker.img}
                    alt={speaker.name}
                  />
                </div>
              ))}
            </div>
          </section>
          <section className="plenary-grid">
            <p className="snn-user-homa-main-content-text">Plenaristas</p>
            <div className="snn-user-home-speakers-wrapper">
              {KeynoteList.map((speaker) => (
                <div
                  className="snn-user-home-main-speaker-wrapper"
                  key={speaker.name}
                  onClick={() => selectSpeaker(speaker.id, KeynoteList)}
                >
                  <img
                    className="snn-user-home-main-speaker-wrapper-speaker"
                    src={speaker.img}
                    alt={speaker.name}
                  />
                </div>
              ))}
            </div>
          </section>
        </div>
        <Sponsors />
        <section className="snn-page-section ">
          <h1 className='snn-title'>Registro y participación</h1>
          <p>
            En el marco del Año Internacional de la Ciencia y Tecnología Cuántica, el Departamento de Óptica de CICESE
            tiene el honor de invitar a investigadores, estudiantes y profesionales con interés en las áreas de la
            mecánica cuántica y tecnologías relacionadas a participar en el simposio &#34;Fronteras Cuánticas: Discusión
            y Progreso&#34;, un espacio para el intercambio de ideas y avances en la frontera del conocimiento, el cual
            se llevará a cabo dentro de las instalaciones del CICESE los días 11 y 12 de septiembre del 2025.
          </p>
          <p>
            Se recibirán trabajos en las siguientes modalidades:
          </p>
          <ul>
            <li>Pláticas cortas: Presentaciones orales de 10 minutos más 5 minutos para preguntas. Se cuenta con un
              número limitado de pláticas cortas, por lo que los trabajos que no sean seleccionados para plática, podrán
              participar con póster.</li>
            <li>Posters: Es requerimiento que el autor esté presente durante toda su sesión, que será el día 11 de
              septiembre. Los carteles deberán ser legibles desde una distancia de 2 m y deberán tener un tamaño
              aproximado de 1.3 m x 0.9 m.</li>
          </ul>
          <p>
            Todos los trabajos deberán estar relacionados con la mecánica cuántica.
          </p>
          <h3 className='snn-title'>Envío de trabajos</h3>
          <p>
            La plataforma para el envío de resúmenes estará disponible a partir del 01 julio de 2025, fecha en la que también se podrán descargar los templates (para el resumen, pláticas y pósters). Los interesados podrán someter sus propuestas a través de la página web oficial del evento: quantum2025.mx.
          </p>
          <p>
            El resumen debe incluir una breve descripción del tema, objetivos y resultados principales (máximo de 2 páginas). Podrá contener imágenes.
          </p>
          <h3 className='snn-title'>Fechas importantes</h3>
          <ul>
            <li>Apertura de la plataforma de envío: 30 de junio de 2025</li>
            <li>Fecha límite para someter resúmenes: 22 de agosto de 2025</li>
            <li>Notificación de aceptación: 25 de agosto de 2025</li>
            <li>Aceptación de trabajos: viernes 29 de agosto</li>
          </ul>
          <p>
            La inscripción al simposio será gratuita, pero es necesario realizar el registro anticipado en la página oficial del evento por cuestiones de logística. Por lo anterior, se invita a registrarse a más tardar el 1 de septiembre.
          </p>
          <h2 className='snn-title'>
            ¡Te esperamos en Ensenada este septiembre!
          </h2>
        </section>
      </div>
      <Footer />
    </>
  );
});
HomeWrapper.displayName = 'HomeWrapper';
export default HomeWrapper;
